import {Component, computed, input} from '@angular/core';
import {NgClass} from "@angular/common";
import {LoyaltyScoreBarBackgroundColors, LoyaltyScoreBarColors} from '../loyalty-score-bar-colors';
import {LoyaltyLevel, Size} from '../../../services/model';

@Component({
  selector: 'lib-loyalty-radial-bar',
  imports: [
    NgClass
  ],
  templateUrl: './loyalty-radial-bar.component.html',
  styleUrl: './loyalty-radial-bar.component.scss'
})
export class LoyaltyRadialBarComponent {
  size = input<Size>(Size.SMALL);
  containerClass = computed(() => {
    return {[this.size().toLowerCase()]: true}
  });
  sizeConstant = computed<number>(() => {
    switch (this.size()) {
      case Size.SMALL:
        return -1;
      case Size.BIG:
        return 1;
    }
  })
  loyaltyScore = input.required<number>();
  loyaltyLevel = input.required<LoyaltyLevel>();
  loyaltyColor = computed(() => {
    if (this.loyaltyLevel() == LoyaltyLevel.DEVOTED) {
      return LoyaltyScoreBarColors.DEVOTED;
    } else if (this.loyaltyLevel() == LoyaltyLevel.LOYAL || this.loyaltyLevel() == LoyaltyLevel.FREQUENT) {
      return LoyaltyScoreBarColors.LOYAL;
    } else if (this.loyaltyLevel() == LoyaltyLevel.CASUAL) {
      return LoyaltyScoreBarColors.CASUAL;
    } else {
      return LoyaltyScoreBarBackgroundColors.STRANGER;
    }
  });

  backgroundColor = computed(() => {
    if (this.loyaltyLevel() == LoyaltyLevel.DEVOTED) {
      return LoyaltyScoreBarBackgroundColors.PURPLE;
    } else if (this.loyaltyLevel() == LoyaltyLevel.LOYAL || this.loyaltyLevel() == LoyaltyLevel.FREQUENT) {
      return LoyaltyScoreBarBackgroundColors.LOYAL;
    } else if (this.loyaltyLevel() == LoyaltyLevel.CASUAL) {
      return LoyaltyScoreBarBackgroundColors.CASUAL;
    } else {
      return LoyaltyScoreBarBackgroundColors.STRANGER;
    }
  });

  // SVG circle properties
  radius: number = 8;
  strokeWidth: number = 10;
  circumference: number = 2 * Math.PI * this.radius;
  strokeDashoffset = computed(() => {
    const progressPercentage = Math.max(0, Math.min(this.loyaltyScore() * 10, 100));
    return this.circumference - (progressPercentage / 100) * this.circumference;
  });

  protected readonly Size = Size;
}
